import moment from 'moment';

import { PERIOD } from './period';

export const INTERVAL = {
  [PERIOD.DAY](date) {
    return {
      head: moment(date)
        .startOf('day')
        .toISOString(),
      tail: moment(date)
        .endOf('day')
        .toISOString(),
    };
  },
  [PERIOD.WEEK]() {
    return {
      head: moment()
        .startOf('day')
        .subtract(6, 'day')
        .toISOString(),
      tail: moment()
        .endOf('day')
        .toISOString(),
    };
  },
  [PERIOD.MONTH]() {
    return {
      head: moment()
        .startOf('day')
        .subtract(1, 'month')
        .toISOString(),
      tail: moment()
        .endOf('day')
        .toISOString(),
    };
  },
  [PERIOD.QUARTER]() {
    return {
      head: moment()
        .startOf('month')
        .subtract(2, 'month')
        .toISOString(),
      tail: moment()
        .endOf('month')
        .toISOString(),
    };
  },
  [PERIOD.YEAR]() {
    return {
      head: moment()
        .startOf('month')
        .subtract(11, 'month')
        .toISOString(),
      tail: moment()
        .endOf('month')
        .toISOString(),
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/constants/interval.js